






































import Vue from 'vue'

import {State} from '../store'
import {api} from '../singleton'
import easyapi, { showSnackbar } from '@/easyapi'
import DeviceTypeIcon from '@/components/DeviceTypeIcon.vue'
import DeviceVendorIcon from '@/components/DeviceVendorIcon.vue'
import HpdIcon from '@/components/HpdIcon.vue'
import AliveIndicator from '@/components/AliveIndicator.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import { PropValidator, RenderContext } from 'vue/types/options'
import { vuetifyThemeAware } from '@/mixins'
import mixins from 'vue-typed-mixins'
import { IDevice } from '@/types/model'
import { dev_property_t } from '@/store/modules/pref'
import moment from 'moment'
import i18n from '@/i18n'
import { getMatrixMap, getExtenderActiveUsage, ExtenderActiveStateSummary, devIsOnline } from '@/utils'
export default mixins(vuetifyThemeAware).extend({
  components: {
    DeviceTypeIcon,
    DeviceVendorIcon,
    AliveIndicator,
    PreviewScreen,
    HpdIcon,
  },
  props: {
    device: {
      type: Object
    } as PropValidator<IDevice>
  },
  computed: {
    showingField (): dev_property_t { return this.$s.$state.pref.deviceList.showingField },
    usage (): ExtenderActiveStateSummary {
      const tmp = getExtenderActiveUsage(this.$state, this.device)
      return tmp
    },
    showRightSide (): boolean {
      return (this.$state.common.windowSize.width) > 550
    },
    cannotMap (): boolean {
      return this.device.deviceType === 'RX' && !devIsOnline(this.device)
    }
  },
  methods: {
    blinkLed (): void { easyapi.blinkLed(this, this.device) },
    openDeviceRenameDialog (): void {
      this.$router.push({ name: 'matrix_rename', params: {mac: this.device.mac} })
    },
    openMatrixRemapDialog (): void {
      if (this.cannotMap) {
        showSnackbar(this.$t('matrix.cannotMapOfflineRx'), 'warning')
        return
      }
      this.$router.push({ name: 'matrix_remap', params: {master_mac: this.device.mac} })
    }
  }
})
